// Third party
import { PayloadAction } from '@reduxjs/toolkit';

// Components
import { IRootState } from './type';
import { initialState } from './slice';

const reducers = {
  setVcatKitsData: (state: IRootState, action: PayloadAction<IRootState['vcat_kits']>) => ({
    ...state,
    vcat_kits: action.payload,
  }),
  deleteVcatKit: (state: IRootState, action: PayloadAction<number>) => ({
    ...state,
    vcat_kits: state.vcat_kits.filter((kit) => kit.id !== action.payload),
  }),
  updateVcatKit: (state: IRootState, action: PayloadAction<any>) => {
    const index = state.vcat_kits.findIndex(k => k.id === action.payload.id);
    if (index !== -1) {
      state.vcat_kits[index] = {
        ...state.vcat_kits[index],
        ...action.payload,
      };
    }
  },
  resetVcatKitsData: () => initialState,
};

export { reducers };
